import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetReportListReq, GetReportListResp, Filter } from './types'

export const getReportListAction = createAsyncAction(
  'admin/report/performance/GET_LIST_REQ',
  'admin/report/performance/GET_LIST_RESP',
  'admin/report/performance/GET_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()

export const updateFilter = createStandardAction(
  'admin/report/performance/UPDATE_FILTER_ACTION'
)<Filter, void>()

export const clearFilter = createStandardAction(
  'admin/report/performance/CLEAR_FILTER_ACTION'
)<void>()

export const sortingTask = createStandardAction(
  'admin/report/performance/SORTING'
)<{
  name: string
  sort?: string
}>()

export const exportReportListAction = createAsyncAction(
  'admin/report/performance/EXPORT_LIST_REQ',
  'admin/report/performance/EXPORT_LIST_RESP',
  'admin/report/performance/EXPORT_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()
